export default __webpack_public_path__ + "static/media/NoAvatar.21cbaa15.png";